import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { LayoutComponent } from './layout.component';
import { RouterModule } from '@angular/router';
import { ComponentModule } from '../../pc/_component/component.module';
import { RespComponentModule } from '../../resp/_component/respComponent.module';
import { InquiryModule } from '../../pc/inquiry/inquiry.module';
// import { CookieModule } from 'ngx-cookie';
@NgModule({
  declarations: [LayoutComponent],
  imports: [
    CommonModule,
    ComponentModule,
    InquiryModule,
    RespComponentModule,
    RouterModule,
    SharedModule.forRoot(),
    // CookieModule.forRoot(),
  ],
  // entryComponents: [LayoutComponent],
  exports: [LayoutComponent],
})
export class LayoutModule {}
